const DhHelper = {};

DhHelper.install = function (Vue, options) {

    Vue.getStatusFromPosition = function (posId, statuses) {
        return getStatusFromPosition(posId, statuses)
    };

    Vue.getAppointmentStatus = function (currentAppointment){
        let appointmentStatus = currentAppointment.appointmentTypeStatus;
        if ((!appointmentStatus || appointmentStatus === '') && (currentAppointment.status === "OnTheWay" || currentAppointment.status === "NoBadge")) {
            appointmentStatus = "SUBSCRIPTIONS";
        }
        return appointmentStatus;
    };

    //Get value for a specific key in an array to key-value pairs
    Vue.getValueForKey = function (arrayToSearch, keyToFind) {
        return getValueForKey(arrayToSearch, keyToFind);
    };

    function getValueForKey(arrayToSearch, keyToFind) {
        let value = null;
        for (let i = 0; i < arrayToSearch.length; i++) {
            if (keyToFind === arrayToSearch[i].key) {
                value = arrayToSearch[i].value;
                break;
            }
        }
        return value;
    }

    function getStatusFromPosition(posId, statuses) {
        let status = null;
        for (let i = 0; i < statuses.length; i++) {
            let positionsInStatus = statuses[i].positions;
            if (positionsInStatus) {
                for (let j = 0; j < positionsInStatus.length; j++) {
                    if (positionsInStatus[j].id === posId) {
                        status = statuses[i];
                        break;
                    }
                }
            }
        }
        return status;
    }

};

export default DhHelper;